import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ReinforcementRepository from '../../../repositories/ReinforcementRepository';
import ReinforcementsDataRepository from '../../../../data/repositories/ReinforcementDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

// Default saga implementation for unregister waiting list
export default function* saga(action: any): any {
  try {
    const { parameters } = action;
    yield put({ type: Types.UNREGISTER_REINFORCEMENT_WAITING_LIST_REQUEST });
    XCheckpointManager.registerStart(
      'reinforcements - unregister waiting List'
    );
    const reinforcementRepository: ReinforcementRepository =
      new ReinforcementsDataRepository();
    const waitingListResponse = yield call(
      [
        reinforcementRepository,
        reinforcementRepository.unsubscribeToWaitingList
      ],
      parameters
    );
    XCheckpointManager.registerEnd('reinforcements - unregister waiting List');
    if (!waitingListResponse) {
      yield put({
        type: Types.UNREGISTER_REINFORCEMENT_WAITING_LIST_FAILURE,
        error: 'Lo sentimos, ocurrió un problema inesperado'
      });
      return;
    }

    if (waitingListResponse.status === 'Error') {
      yield put({
        type: Types.UNREGISTER_REINFORCEMENT_WAITING_LIST_FAILURE,
        error: waitingListResponse.message
      });
      return;
    }
    yield put({
      type: Types.UNREGISTER_REINFORCEMENT_WAITING_LIST_SUCCESS,
      data: waitingListResponse
    });
  } catch (error: any) {
    yield put({
      type: Types.UNREGISTER_REINFORCEMENT_WAITING_LIST_FAILURE,
      error: `Lo sentimos, ocurrió un problema inesperado ${
        error.message || error
      }`
    });
  }
}
